import { render, staticRenderFns } from "./cara-kerja.vue?vue&type=template&id=4672280c&scoped=true"
import script from "./cara-kerja.vue?vue&type=script&lang=js"
export * from "./cara-kerja.vue?vue&type=script&lang=js"
import style0 from "./cara-kerja.vue?vue&type=style&index=0&id=4672280c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4672280c",
  null
  
)

export default component.exports